import * as React from "react";
import { useNavigate, useRouterState } from "@tanstack/react-router";
import { useQueryClient } from "@tanstack/react-query";
import { useAuth } from "@app/providers/auth";
import {
  createLoginRedirectSearch,
  isAuthRoutePath,
} from "@app/router/routeGuards";

export function buildLoginRedirectSearch(
  currentHref?: string | null,
  currentPathname?: string | null,
) {
  const path = currentHref || currentPathname || "";
  if (!path || isAuthRoutePath(currentPathname || path)) {
    return { reason: "manual" };
  }

  return createLoginRedirectSearch(
    { href: path, pathname: currentPathname },
    "manual",
  );
}

export function useSignOut() {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const { location } = useRouterState({
    select: (s) => ({ location: s.location }),
  });
  const queryClient = useQueryClient();

  return React.useCallback(async () => {
    const search = buildLoginRedirectSearch(location.href, location.pathname);
    await logout({ reason: "manual" });
    try {
      queryClient.clear();
    } catch {
      // ignore cache clear failures
    }
    navigate({ to: "/login", search: search as any, replace: true } as any);
  }, [location.href, location.pathname, logout, navigate, queryClient]);
}
